import { Card } from '@/components/ui/card';
import { motion } from 'framer-motion';
import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react';
import { ReactElement } from 'react';

interface Competitor {
  id: string;
  name: string;
  accountUrl: string;
  avatarUrl: string;
  trending: 'up' | 'down';
}

// Mock data - would normally come from an API
const MOCK_COMPETITORS: Competitor[] = [
  {
    id: '1',
    name: 'Competitor A',
    accountUrl: '#',
    avatarUrl: 'https://api.dicebear.com/7.x/shapes/svg?seed=1',
    trending: 'up',
  },
  {
    id: '2',
    name: 'Competitor B',
    accountUrl: '#',
    avatarUrl: 'https://api.dicebear.com/7.x/shapes/svg?seed=2',
    trending: 'down',
  },
  {
    id: '3',
    name: 'Competitor C',
    accountUrl: '#',
    avatarUrl: 'https://api.dicebear.com/7.x/shapes/svg?seed=3',
    trending: 'up',
  },
  {
    id: '4',
    name: 'Competitor D',
    accountUrl: '#',
    avatarUrl: 'https://api.dicebear.com/7.x/shapes/svg?seed=4',
    trending: 'up',
  },
  {
    id: '5',
    name: 'Competitor E',
    accountUrl: '#',
    avatarUrl: 'https://api.dicebear.com/7.x/shapes/svg?seed=5',
    trending: 'down',
  },
  {
    id: '6',
    name: 'Competitor F',
    accountUrl: '#',
    avatarUrl: 'https://api.dicebear.com/7.x/shapes/svg?seed=6',
    trending: 'up',
  },
];

export const CompetitorAnalysisCard = (): ReactElement => {
  const handleCompetitorClick = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <Card className="p-5 h-max w-full">
      <div className="flex flex-col gap-2">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <h2 className="text-lg font-semibold">Competitor Analysis</h2>
        </motion.div>

        <div className="mt-4">
          <div className="grid grid-cols-3 gap-4">
            {MOCK_COMPETITORS.map((competitor) => (
              <div
                key={competitor.id}
                className="flex flex-col items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity"
                onClick={() => handleCompetitorClick(competitor.accountUrl)}>
                <div className="relative">
                  <img
                    src={competitor.avatarUrl}
                    alt={competitor.name}
                    className="w-16 h-16 rounded-full"
                  />
                  <div
                    className={`absolute -top-1 -right-1 p-1 rounded-full ${
                      competitor.trending === 'up'
                        ? 'bg-green-500'
                        : 'bg-red-500'
                    }`}>
                    {competitor.trending === 'up' ? (
                      <ArrowUpIcon className="w-3 h-3 text-white" />
                    ) : (
                      <ArrowDownIcon className="w-3 h-3 text-white" />
                    )}
                  </div>
                </div>
                <span className="text-sm font-medium text-center">
                  {competitor.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Card>
  );
};
